const janusColors = {
	purple: '#4361ed'
};

export default janusColors;